export default "__VITE_ASSET__CfBV$ltD__"